module.exports = __webpack_public_path__ + "img/IE.ffb3051f.svg";